module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-259.a92c4e2.woff2";